/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-radio-list-item {
  background-color: #fff;
  display: block;
}
.ux-radio-list-item:hover {
  background-color: #e7e7e7;
}
.ux-radio-list-item .ux-radio-button-field {
  display: block;
}
.ux-radio-list-item .ux-radio-button {
  width: 100%;
}
.ux-radio-list-item .ux-radio-button__input:focus-visible + .ux-radio-button__label {
  border: solid 1px var(--ux-button-focus-border-color);
}
.ux-radio-list-item .ux-radio-button__label {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  color: #727272;
  font-size: 15px;
  margin: 0;
  padding: 10px;
  text-transform: none;
}
.ux-radio-list-item--active .ux-radio-button__label {
  color: #131313;
}
.ux-radio-list-item .ux-radio-button__label::before,
.ux-radio-list-item .ux-radio-button__label::after {
  display: none;
}